<template>
	<div>
		<div class="css-h81dkj">
			<!-- <div class="date">13:42<br />21 Dec</div> -->
			<div class="line-wrapper">
				<div class="circle">
					<i
						:class="{
							warning: history && !history.isPlaceholder && !isDelivered,
							danger:
								history &&
								!history.isPlaceholder &&
								dangerStatuses.includes(history.status),
							active: history && !history.isPlaceholder && isDelivered,
						}"
						class="shipment-history-icon material-icons warning"
						>{{ icon }}</i
					>
				</div>
				<div class="line"></div>
			</div>
			<div class="status-wrapper">
				<div class="status" v-html="this.sanitizeHtml(tooltip)"></div>
				<!-- <div class="city">Bandung Sukasari</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getShipmentIcon, duplicateVar, sanitizeHtml } from '@/lib/helper';

dayjs.extend(customParseFormat);

export default {
	name: 'ShipmentTracking',
	props: {
		courier: {
			type: String,
			default: 'sicepat',
		},
		history: {
			type: Object,
		},
	},
	data() {
		return {
			dangerStatuses: [
				'CODB',
				'LOST',
				'BROKE',
				'CANCELLED',
				'RTS',
				'(RTS) Return To Shipper',
				'RETURN TO SHIPPER',
				'HILANG',
				402,
				'POD - UNDELIVERED',
				'SHIPMENT RETURN TO CLIENT',
				'DELIVERY RETURN',
			],
			successStatuses: ['DELIVERED', 200, 'POD - DELIVERED'],
			courierSuccessStatuses: {
				sap: ['DELIVERED', 200, 'POD - DELIVERED'],
				sicepat: ['DELIVERED', 200, 'POD - DELIVERED'],
				jne: ['DELIVERED', 200, 'POD - DELIVERED'],
				jnt: ['DELIVERED', 200, 'POD - DELIVERED'],
				jx: [150],
				ninja: ['DELIVERED'],
			},
		};
	},
	methods: {
		sanitizeHtml,
		statusLabel(history) {
			return history?.description ? `${history?.notes} (${history.status})` : `${history?.status}`;
		},
	},
	computed: {
		icon() {
			const status = this.history ? this.history.status : '';
			const courier = this.courier;
			const icon = getShipmentIcon(status, courier);
			return icon;
		},
		tooltip() {
			let tooltip = '';
			if (this.history) {
				const notes = this?.history?.notes ?? '';
				const status = this.statusLabel(this.history) ?? '';
				tooltip = notes;
				let date = this?.history?.date ?? '';
				if (this.courier === 'jne') {
					date = this.history.date || '';
				} else if (this.history.date) {
					const historyDate = duplicateVar(this.history.date);
					date = dayjs(historyDate).format('DD-MM-YYYY HH:mm');
				}

				if (!this.history.isPlaceholder) {
					tooltip = /** html */ `
						<div><b>${date}</b></div>
						<div><b>${status}</b></div>
						<div>${notes}</div>
					`;
				}
			}
			return tooltip;
		},
		isDelivered() {
			const successStatuses = this.courierSuccessStatuses[this.courier]
				? this.courierSuccessStatuses[this.courier]
				: [];
			return successStatuses.includes(this.history.status);
		},
	},
};
</script>
